document.addEventListener("DOMContentLoaded", async function () {
  const extraText = document.querySelector(".collection-grid .extra-text");
  const readMore = document.querySelector(".collection-grid .read-more");
  const readLess = document.querySelector(".collection-grid .read-less");
  const productGrid = document.querySelector(".collection .grid-products");
  const productImages = productGrid ? productGrid.querySelectorAll(".ed-product-block .product-image img") : [];
  
  function handleScroll() {
    const aside = document.querySelector('.collection-grid aside');
    if (!aside) return;

    const scrollY = window.scrollY || window.pageYOffset;
    const isMobile = window.innerWidth < 990;
    const threshold = isMobile ? 80 : 157;
    
    if (scrollY >= threshold) {
      aside.classList.add('scrolled');
    } else {
      aside.classList.remove('scrolled');
    }
  }
  
  // Initial check
  handleScroll();
  
  // Listen to scroll events
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Listen to resize events to recalculate threshold
  window.addEventListener('resize', handleScroll, { passive: true });

  productImages.forEach((img) => {
    const rect = img.getBoundingClientRect();
    const isInViewport = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

    if (isInViewport) {
      // Images in viewport: prioritize loading
      img.setAttribute('fetchpriority', 'high');
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');
    } else {
      // Images outside viewport: lazy load
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
    }
  });

  if (extraText && readMore && readLess) {
    readMore.addEventListener("click", () => {
      extraText.classList.add("open");
      readMore.classList.add("hidden");
      readLess.classList.remove("hidden");
    });
    readLess.addEventListener("click", () => {
      extraText.classList.remove("open");
      readMore.classList.remove("hidden");
      readLess.classList.add("hidden");
    });
  }

  function updateCollectionBannerHeight() {
    const collectionBanner = document.querySelector(
      ".collection-grid .featured-image img"
    );
    const collectionProductImage = document.querySelector(
      ".collection-grid .ed-product-block img"
    );

    if (collectionBanner && collectionProductImage) {
      collectionBanner.style.height =
        collectionProductImage.offsetHeight + "px";
    }
  }

  updateCollectionBannerHeight();
  window.addEventListener("resize", updateCollectionBannerHeight);

  const observer = new MutationObserver(() => {
    updateCollectionBannerHeight();
  });
  // (you’ll want to hook the observer to the facet container here)
});
